<template>
  <div id="privacy">
    <section>
      <header>
        <h2>Privacy Policy</h2>
      </header>
      <div>
        <p><em>CSHD</em> uses enterprise-grade services and industry-standard security practices for storing and communicating all data. <strong><em>CSHD</em> does not share, sell, or advertise with user data in any capacity.</strong></p>

        <p>Any potentially user-identifying data gathered is used <strong>exclusively for the purpose of coordinating enrollments, communicating with staff</strong>, improving the app, fixing bugs in the code, providing support, etc.</p>

        <p><strong>If you navigate/use the site/app</strong>, common web traffic stats are collected:</p>
        <ul>
          <li>basic analytics information, like: pageviews, IP addresses, dates and times</li>
          <li>device-type information, e.g.: operating system, web browser name and version</li>
          <li>information required by third-party services in order to function; for instance: cookies for determining login state</li>
        </ul>

        <p><strong>If you enroll for a class</strong>, only the data you explicitly input will be stored, such as:</p>
        <ul>
          <li>your email address</li>
          <li>your name</li>
          <li>information about you and/or your dancer(s), such as birthdates and allergies/medical conditions</li>
        </ul>
      </div>
    </section>
    <section class="bg-tartan">
      <header>
        <h2>Data Deletion</h2>
      </header>
      <div>
        <p>If you have created an account and would like your data permanently deleted from all of our systems—for whatever reason—please <router-link to="/#contact"><strong>contact us</strong></router-link> to make this request.</p>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'privacy',
};
</script>

<style lang="postcss">
</style>



// WEBPACK FOOTER //
// Privacy.vue?49441b3e